import React from 'react';
import { Row, Icon, Text, Checkbox, Flex, Tooltip } from '@upsales/components';
import './ReportcenterFilterRow.scss';

export type Props = Partial<typeof Row> & {
	key: number | string;
	title: string;
	selected: boolean;
	bold?: boolean;
	onClick: () => void;
	onReset?: () => void;
	noCheckbox?: boolean;
	inactive?: boolean;
	space?: string;
	disabled?: boolean;
	disabledTooltip?: string;
};

const ReportcenterFilterRow = ({
	title,
	selected,
	bold = false,
	onReset,
	noCheckbox,
	inactive,
	disabled,
	disabledTooltip,
	onClick,
	space = 'pll ptm pbm prl',
	...props
}: Props) => {
	const renderFilterRow = () => (
		<Flex
			className="ReportcenterFilterRow"
			space={space}
			justifyContent="space-between"
			{...props}
			onClick={disabled ? undefined : onClick}
		>
			<Flex alignItems="center">
				{noCheckbox ? null : <Checkbox disabled={disabled} checked={selected} space="mrl" size="sm" />}
				<Text bold={bold} italic={disabled || inactive} color={disabled || inactive ? 'grey-9' : undefined}>
					{title}
				</Text>
			</Flex>
			{selected && onReset ? (
				<Flex alignItems="center">
					<Icon
						color="grey-10"
						name="times"
						onClick={e => {
							e.stopPropagation();
							onReset?.();
						}}
					/>
				</Flex>
			) : null}
		</Flex>
	);

	return disabledTooltip ? (
		<Tooltip title={disabledTooltip} disabled={!disabled || !disabledTooltip}>
			{renderFilterRow()}
		</Tooltip>
	) : (
		renderFilterRow()
	);
};

export default ReportcenterFilterRow;
